/**
 * @deprecated The `apiResources` collection of reducers has been replaced by the one in `./apDataReducers`.
 */

import { combineReducers }      from 'redux-immutable';
import buildAllResourceReducers from './utils/apiResources/buildAllResourceReducers';
import resources                from '../config/resources.config';
import deprecated               from '../utils/deprecated';

deprecated('The `apiResources` collection of reducers has been replaced by the one in `./apDataReducers`');

const reducers = Object.keys(resources).reduce((accumulator, resource) => {

  accumulator[resource] = buildAllResourceReducers(resource);

  return accumulator;

}, {});

export default combineReducers(reducers);


// WEBPACK FOOTER //
// ./src/reducers/apiResources.js